document.addEventListener('DOMContentLoaded', function () {
  const KEY = 'privacy_mode';

  // Function to apply privacy mode (toggle on/off)
  function applyPrivacyMode(enabled) {
    // Log to check if the class is being toggled
    console.log('Privacy mode enabled:', enabled);
    
    // Toggle the privacy mode class on the root element (html)
    document.documentElement.classList.toggle('privacy-mode', enabled);
    
    // Ensure the toggle matches the state
    document.querySelectorAll('#privacyModeToggle').forEach(t => t.checked = enabled);

    // Keep CSS available for both customer view ON and OFF
    addPrivacyModeStyles();
  }

  // Function to add privacy mode CSS
  function addPrivacyModeStyles() {
    // Log to ensure we're adding styles
    console.log('Adding privacy mode styles');
    
    const existingStyle = document.getElementById('privacy-mode-styles');
    if (existingStyle) {
      return;  // Don't add if it's already present
    }
    
    const style = document.createElement('style');
    style.id = 'privacy-mode-styles';
    style.textContent = `
      .cart-original-price {
        display: none !important;
      }

      html.privacy-mode .cart__discount,
      html.privacy-mode .cart-item__discount,
      html.privacy-mode .cart__discounts,
      html.privacy-mode .discounts,
      html.privacy-mode .cart__total__discount {
        display: none !important;
      }

      html.privacy-mode del {
        display: inline !important;
        opacity: 1 !important;
        text-decoration: none !important;
      }

      html.privacy-mode .cart__total__price_discount {
        display: none !important;
      }

      html.privacy-mode .cart-original-price {
        display: inline !important;
      }

      .restrict-product #MainContent > *:not(#restricted-product) {
        display: none !important;
      }

      html.restrict-product #MainContent {
        min-height: 0 !important;
      }

      html.noproducts #MainContent {
        min-height: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Function to remove privacy mode CSS
  function removePrivacyModeStyles() {
    // Do not remove the CSS.
    // The base .cart-original-price rule must stay active when customer view is OFF.
    console.log('Privacy mode styles remain active');
  }

  addPrivacyModeStyles();

  // Default customer view ON, but do not force it after user changes the toggle
  let savedState = sessionStorage.getItem(KEY) || localStorage.getItem(KEY) || '1';

  sessionStorage.setItem(KEY, savedState);
  localStorage.setItem(KEY, savedState);

  applyPrivacyMode(savedState === '1');

  // WRITE state to BOTH storages when toggle changes
  document.addEventListener('change', function (event) {
    const toggle = event.target.closest('#privacyModeToggle');

    if (!toggle) {
      return;
    }

    const enabled = toggle.checked ? '1' : '0';

    sessionStorage.setItem(KEY, enabled);
    localStorage.setItem(KEY, enabled);

    // Apply privacy mode dynamically
    applyPrivacyMode(enabled === '1');
  });

  document.addEventListener('click', function(e) {
    // Check if the clicked element is the 'displaymessage' button (for showing the message)
    if (e.target.closest('.displaymessage')) {
      const button = e.target.closest('.btn');
      const hiddenMessage = button.parentElement.querySelector('.co-op-notavailable-msg');
      
      if (hiddenMessage) {
        hiddenMessage.classList.remove('hidden');
      }
    }

    // Check if the clicked element is the 'hide_error' button (to close the message)
    if (e.target.closest('.hide_error')) {
      e.stopPropagation();

      const message = e.target.closest('.co-op-notavailable-msg');
      
      if (message) {
        message.classList.add('hidden');
      }
    }
  });
});